module.exports = __webpack_public_path__ + "static/layout_image_3-9d6be4eba1c401e5176be7ec256e6d74.png";